import { types } from "../actions";

const initialState = {
    selectedCameraQR: "",
    companionSelected: { name: "", id: "", qrcode: "" },
    floorSelected: { name: "", id: "", imageid: "", imageurl: '' },
    cameraName: "",
    areaSelected: { id: "", name: "" },
    subAreaSelected: { id: "", name: "" },
    siteSelected: { name: "", id: "" },
    floorAreas: [],
    fovNames: [],
    cameraBlurValue: "",
    camDetails: {},
    blurValues: [
        {label: 'Object blurring', value: 'OBJECT_BLUR', children: 'Anonymize people and vehicles by blurring their image'},
        {label: 'No blurring', value: 'NO_BLUR', children: 'Do not anonymize people, vehicles, or faces'},
    ],
    unpairedCamDetails: {name: "", id: "", uid: "", customdata: {cameralocation: {top: 0, left: 0}}},
    camPosition: {top: 0, left: 0},
    companionList: [],
    calibrating: false,
    refreshUnpairedList: false, 
};

const cameraonboardingReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.COMPANION_SELECTED: {
            return {
                ...state,
                companionSelected: action.value
            };
        }
        case types.FLOOR_SELECTED: {
            return {
                ...state,
                floorSelected: {...state.floorSelected, ...action.value}
            }
        }
        case types.AREA_SELECTED: {
            return {
                ...state,
                areaSelected: action.value
            }
        }
        case types.SUBAREA_SELECTED: {
            return {
                ...state,
                subAreaSelected: action.value
            }
        }
        case types.CAMERA_UPDATED: {
            return {
                ...state,
                cameraName: action.value
            }
        }
        case types.SITE_SELECTED: {
            return {
                ...state,
                siteSelected: action.value
            }
        }
        case types.FLOOR_AREAS: {
            return {
                ...state,
                floorAreas: action.value
            }
        }
        case types.GET_FOVNAMES: {
            return {
                ...state,
                fovNames: action.value
            }
        }
        case types.CAM_BLUR_VALUE: {
            return {
                ...state,
                cameraBlurValue: action.value
            }
        }
        case types.RESET_ONBOARD_CAMERA: {
            return initialState;
        }
        case types.SET_CAM_DETAILS: {
            return {
                ...state,
                camDetails: action.value
            }
        }
        case types.SET_CAM_QR: {
            return {
                ...state,
                selectedCameraQR: action.value
            }
        }
        case types.SET_UNPAIRED_CAM_DETAILS: {
            return {
                ...state,
                unpairedCamDetails: {
                    ...state.unpairedCamDetails, 
                    ...(action.value?.qrcode && {name: action.value?.qrcode, id: action.value?.qrcode, uid: action.value?.qrcode}),
                    customdata: {
                        ...state.unpairedCamDetails.customdata,
                        cameralocation: {
                            ...state.unpairedCamDetails.customdata.cameralocation,
                            ...(action.value?.position && {top: action.value?.position?.top, left: action.value?.position?.left})
                        }
                    }
                }
            }
        }
        case types.SET_CAM_POSITION: {
            return {
                ...state,
                camPosition: {
                    ...state.camPosition, 
                    ...({top: action.value?.position.top, left: action.value?.position?.left})
                }
            }
        }
        case types.SET_COMPANION_LIST: {
            return {
                ...state,
                companionList: action.value
            }
        }
        case types.SET_CALIBRATING: {
            return {
                ...state,
                calibrating: action.payload
            }
        }
       
        case types.TRIGGER_UNPAIRED_CAMERAS_REFRESH:
            return {
                ...state,
                refreshUnpairedList: true,
            };

        case types.RESET_UNPAIRED_CAMERAS_REFRESH:
            return {
                ...state,
                refreshUnpairedList: false,
            };
        default:
            return state;
    }
};
export default cameraonboardingReducer;
